import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Form, FormContext, Input, formatGeneralRangeValues } from 'dash-ui';

import { FormFields } from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/constants/constants';
import AverageUnitValueInput from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/components/InventoryInfo/components/AverageUnitValueInput';
import { unitSum } from 'dash-common';

const ExteriorSqftRow = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors } = useContext(FormContext);
  const totalValue = useMemo(() => {
    const min =
      unitSum( 
        formState.averageInteriorSqft?.min,
        formState.averageExteriorSqft?.min,
      );

    const max =
      unitSum( 
        formState.averageInteriorSqft?.max,
        formState.averageExteriorSqft?.max,
      );

    return formatGeneralRangeValues({ min, max });
  }, [formState]);
  
  return (
    <Flex flex={1}>
      <Flex flex={1} flexDirection="column">
        <AverageUnitValueInput fieldKey="exteriorSqft" />
      </Flex>
      <Flex flex={1} flexDirection="column" ml={4} mt={4.75}>
        <Form.Label>{t('forms:labels.totalSqft')}</Form.Label>
        <Input
          w="100%"
          disabled
          value={totalValue}
          placeholder={t('forms:placeholders.totalSqft') || ''}
          $errorType={formErrors[FormFields.TotalSqft]?.type}
        />
        <Form.Feedback $errorType={formErrors[FormFields.TotalSqft]?.type}>
          {formErrors[FormFields.TotalSqft]?.message}
        </Form.Feedback>
      </Flex>
    </Flex>
  );
};

export default ExteriorSqftRow;
